
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import InputGroupTitle from '@devsisters/ui-careers/lib/InputGroupTitle';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"inputgrouptitle"}}>{`InputGroupTitle`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { InputGroupTitle } from '@devsisters/ui/careers';
// 또는 import InputGroupTitle from '@devsisters/ui-careers/lib/InputGroupTitle';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<div style={{ fontSize: \'16px\' }}>\n  <InputGroupTitle error=\"약관에 동의해주세요\">\n    개인정보 수집 및 이용 동의\n  </InputGroupTitle>\n  <InputGroupTitle required>\n    Q. 어디서 채용공고를 보고 지원하셨나요?\n  </InputGroupTitle>\n  <InputGroupTitle guide=\"PDF로 제출\">제출서류</InputGroupTitle>\n</div>'} __scope={{props: this ? this.props : props,State,InputGroupTitle}}>
  <div style={{ fontSize: '16px' }}>
    <InputGroupTitle error="약관에 동의해주세요">
      개인정보 수집 및 이용 동의
    </InputGroupTitle>
    <InputGroupTitle required>
      Q. 어디서 채용공고를 보고 지원하셨나요?
    </InputGroupTitle>
    <InputGroupTitle guide="PDF로 제출">제출서류</InputGroupTitle>
  </div>
</Playground>
           </MDXTag>
  }
}
  